import React from 'react'
import { SuccessScreen } from '@screens/Success/SuccessScreen'
import BookingReceivedScreen from '@screens/Success/components/BookingReceivedScreen/BookingReceivedScreen'
import { useConfig } from '@context/ConfigurationContext'
import { useChoiceState } from '@context/ChoiceContext'
import { useContactDetailsState } from '@context/ContactDetailsContext'

const Success = () => {
  const { asModal } = useConfig()
  const contactDetails = useContactDetailsState()
  const { isManualReviewRequired } = useChoiceState()

  if (isManualReviewRequired) {
    return <BookingReceivedScreen contactDetails={contactDetails} asModal={asModal} />
  }

  return <SuccessScreen />
}

export default Success
